var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page"
  }, [_c(_vm.InviteScene, {
    tag: "component",
    attrs: {
      "consumeInviteInfo": _vm.inviteInfo,
      "inviteDeatilInfo": _vm.inviteInfo
    },
    on: {
      "next": _vm.next
    }
  }), _c('div', {
    staticClass: "help"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };